<div
	class="border rounded-md p-5 flex justify-between hover:border-primary-500 transition cursor-pointer">
	<div class="flex gap-5">
		<div>
			@if (paymentMethod()?.type === 'cbu') {
				<img src="images/bank.svg" alt="bank" />
			} @else {
				<img src="images/credit-card.svg" alt="card" />
			}
		</div>
		<div>**** **** **** {{ paymentMethod()?.lastFour }}</div>
	</div>
	@if (paymentMethod()?.selected) {
		<div>
			<svg
				xmlns="http://www.w3.org/2000/svg"
				fill="none"
				viewBox="0 0 24 24"
				stroke-width="1.5"
				stroke="currentColor"
				class="size-6 text-primary-500">
				<path
					stroke-linecap="round"
					stroke-linejoin="round"
					d="M9 12.75 11.25 15 15 9.75M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z" />
			</svg>
		</div>
	}
</div>
